var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowItWorksCharacter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_88861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0003 14.2856C41.7065 14.2856 47.1431 19.882 47.1431 26.7856C47.1431 33.6893 41.7065 39.2857 35.0003 39.2857C28.294 39.2857 22.8574 33.6891 22.8574 26.7856C22.8574 19.8822 28.294 14.2856 35.0003 14.2856ZM35.0003 19.2856C31.0883 19.2856 27.8574 22.6116 27.8574 26.7856C27.8574 30.9597 31.0883 34.2857 35.0003 34.2857C38.9122 34.2857 42.1431 30.9597 42.1431 26.7856C42.1431 22.6116 38.9122 19.2856 35.0003 19.2856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 0C54.33 0 70 15.67 70 35C70 48.0221 62.8884 59.3832 52.3372 65.4113C47.4026 68.253 41.6974 69.9113 35.611 69.9966L35.0001 70C15.67 70 0 54.33 0 35C0 15.67 15.67 0 35 0ZM31.73 47.8572C25.3311 47.8572 19.6479 51.9147 17.5586 57.9406L17.2355 58.9862C22.1964 62.7474 28.3074 64.9104 34.7075 64.9972L35.496 64.996C40.7774 64.9104 45.7273 63.4599 50.0079 60.9818L52.767 59.1528L52.458 58.2045C50.4732 52.1212 44.8532 47.9769 38.4755 47.8596L31.73 47.8572ZM35 5C18.4314 5 5 18.4314 5 35C5 42.9406 8.08505 50.1608 13.1221 55.527C16.1147 47.9208 23.4758 42.8572 31.7302 42.8572H38.1982C46.4719 42.8572 53.848 47.9446 56.8277 55.5804C61.8945 50.2088 65.0001 42.9671 65.0001 35C65 18.4314 51.5686 5 35 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_88861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksCharacter);
export default __webpack_public_path__ + "static/media/how_it_works_character.ea14ba4d084c94c95aedbdb5e708b3ca.svg";
export { ForwardRef as ReactComponent };